import React from "react";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';
import CustomCountdown from "@/modules/Countdown";

class Banner extends React.Component {
  render() {
    const { message = {}, className } = this.props
    console.log(message);
    const bannerClassMap = {
      'vn': 'vn-banner-img',
      'th': 'th-banner-img',
      'ph': 'ph-banner-img'
    }
    const bannerImgClass = bannerClassMap[process.env.REACT_APP_COUNTRY] || 'banner-img';
    return (
      <section id="banner" className={className}>
        <ReactWOW>
          <span className="deco deco-1" />
        </ReactWOW>
        <ReactWOW>
          <span className="deco deco-2" />
        </ReactWOW>
        <ReactWOW>
          <span className="deco deco-3" />
        </ReactWOW>
        <div className="content">
          <div className={bannerImgClass} />
          { message.text && <p className="desc-1">{$t(message.text)}</p> }
          <a className="btn-register" href={message.sighUpLink} target="_blank" rel="noopener noreferrer">{$t(message.registerBtn)}</a>
          <p className="desc-2">{$t(message.explain)}</p>
          { message.isPH ? <CustomCountdown endDate={new Date($t(message.countDown))}/> : null }
        </div>
        <ReactWOW>
          <span className="deco deco-4" />
        </ReactWOW>
        <ReactWOW>
          <span className="deco deco-5" />
        </ReactWOW>
        <ReactWOW>
          <span className="deco deco-6" />
        </ReactWOW>
      </section>
    );
  }
}

export default Banner;
